import * as React from 'react';
import { AppUser } from 'Src/views/App/App';
import { FormTemplatesManager } from 'Src/components/FormTemplatesManager/FormTemplatesManager';

export const ConsentRequestsTemplateQuestions: React.FC<{ user: AppUser }> = ({ user }) => (
  <FormTemplatesManager
    user={user}
    types={['CONSENT', 'CLUB_BOOKING']}
    title="School form builder"
  />
);

